// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"eb60f07c","428":"dd2d3236","698":"7652dae3","717":"53428b06","997":"26de008c"}[chunkId] + ".chunk.css";
};